/* native-size-chart — size chart modal. Opens the <template> next to the link as a modal in <body>.
   Close: X, overlay (or anywhere outside the dialog), Escape. Docs: docs/NATIVE-SWATCHES-CART.md */
(function () {
  if (window.nativeSizeChartLoaded) return;
  window.nativeSizeChartLoaded = true;
  var open = null;

  function close() {
    if (!open) return;
    open.modal.remove();
    document.documentElement.classList.remove('native-size-chart-open');
    document.removeEventListener('keydown', onKey, true);
    if (open.trigger && open.trigger.focus) open.trigger.focus({ preventScroll: true });
    open = null;
  }

  function onKey(evt) {
    if (evt.key === 'Escape' || evt.key === 'Esc') { evt.preventDefault(); close(); return; }
    if (evt.key !== 'Tab' || !open) return;
    var f = open.modal.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"]), .native-size-chart__table-wrap');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (evt.shiftKey && document.activeElement === first) { evt.preventDefault(); last.focus(); }
    else if (!evt.shiftKey && document.activeElement === last) { evt.preventDefault(); first.focus(); }
  }

  function show(trigger) {
    var tpl = document.getElementById(trigger.getAttribute('data-native-size-chart-open'));
    if (!tpl) return;
    close();
    var modal = tpl.content.firstElementChild.cloneNode(true);
    document.body.appendChild(modal);
    document.documentElement.classList.add('native-size-chart-open');
    open = { modal: modal, trigger: trigger };
    modal.addEventListener('click', function (evt) {
      // X, overlay, or a click in the scroll area outside the dialog
      if (evt.target.closest('[data-native-size-chart-close]') || !evt.target.closest('.native-size-chart__dialog')) close();
    });
    document.addEventListener('keydown', onKey, true);
    var x = modal.querySelector('.native-size-chart__close');
    if (x) x.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest && evt.target.closest('[data-native-size-chart-open]');
    if (!trigger) return;
    evt.preventDefault();
    evt.stopPropagation();   // not the surrounding <label>/variant handlers
    show(trigger);
  }, true);
})();
